import { ruleRunner } from 'validations/ruleRunner';
import { required, minLength } from 'validations/rules';

const Validations = [
  ruleRunner('description', 'descrição', required),
  ruleRunner('trigger_id', 'se isso acontecer', required),
  ruleRunner('option_id', 'faça isso', required),
  ruleRunner('products_id', 'produtos', required, minLength(1))
];

export default Validations;
